import { render, staticRenderFns } from "./AssetStats.vue?vue&type=template&id=25c16902"
import script from "./AssetStats.vue?vue&type=script&lang=js"
export * from "./AssetStats.vue?vue&type=script&lang=js"
import style0 from "./AssetStats.vue?vue&type=style&index=0&id=25c16902&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports